<template>
  <v-card class="py-3" 
          :class="{'px-3' : $vuetify.breakpoint.lgAndUp}"
          elevation="5">
    <p class="text-center headline font-weight-bold">
      Poblaciones (Igualdad de Oportunidades)
    </p>

    <stack 
      ref="stack2"
      :column-min-width="440"
      :gutter-width="8"
      :gutter-height="8"
    >
      <stack-item v-for="gpo in filtered_groups" class="mt-2">
        <v-card class="pa-3" max-width="700" style="margin: 0px auto">
          <span class="title" :id="`title-${gpo.grupo_segmento.id}-${ies.id}`"></span>
          <br>
          <svg :id="`mekko-${gpo.grupo_segmento.id}-${ies.id}`"></svg>
          <v-divider v-if="false"/>
        </v-card>
      </stack-item>
    </stack>


    <v-tooltip 
      color="white"
      bottom 
      v-model="is_tooltip"
      :position-x="posX"
      :position-y="posY"
    >
      <div
        v-if="tt_data"
        class="pa-3"
        :style="{'border': `2px ${calcHeatColor(tt_data.perc)} solid`}"
      >
        <span class="black--text text-left">
          <span class="font-weight-bold">
            {{tt_data.nombre}}: {{tt_data.description}}
          </span>
          <span v-if="tt_data.seg">
            <br>{{`${tt_data.seg}% de ${tt_data.g_seg_name}`}}
          </span>
        </span>
        <br>
        <span class="text-center title" v-html="calcEqTooltip({td:tt_data})">
        </span> <br>
      </div>      
    </v-tooltip>

    <div v-if="false" >
      <span class="headline" :id="`title-${gpo.id}-${ies.id}`"></span>
      <br>
      <svg :id="`mekko-${gpo.id}-${ies.id}`"></svg>
    </div>
  </v-card>
</template>

<script>

import { mapState, } from "vuex";
import * as d3 from 'd3';
import * as d3Array from 'd3-array';
import homeMixin from "../homeMixin";
import { Stack, StackItem } from 'vue-stack-grid';
import TitleCard from "../common/TitleCard";

export default {
  name: 'MekkoChart',
  components: {
    Stack,
    StackItem,
    TitleCard,
  },
  mixins: [homeMixin],
  props:{
    ies:{
      type: Object,
      required: false,
    },
  },
  data(){
    return {
      is_tooltip:false,
      posX:-200,
      posY:-200,
      tt_data: undefined,
      sizes:{
        width: 450,
        height: 450,
        margin_top: 110,
      }
    }
  },
  computed:{
    ...mapState({
      segmentos: state => state.segmentos,
      gpos_segmento: state => state.gpos_segmento,
    }),
    filtered_groups(){
      return this.ies.current_poblations_groups.filter(cpg=> !cpg.no_aplica)
        .slice().sort((a,b)=> 
          d3.ascending(a.grupo_segmento.orden, b.grupo_segmento.orden))
    },
  },
  methods: {
  reflow(){
    this.$refs.stack2.reflow()
  },
  mekkoChart() {
    var vm = this
    var mt = this.sizes.margin_top

    var xScale = d3.scaleLinear()
      .range([0, vm.sizes.width])

    var treemapLayout = d3.treemap()
      .size([vm.sizes.height, vm.sizes.width])
      .round(true)
      .tile(d3.treemapSliceDice)
      .paddingTop(0)
      .padding(0)
      .paddingInner(1)



    d3.selectAll('.mekko-chart' + " > *").remove();

    vm.filtered_groups.forEach(gs=>{

      var chart_id = `#mekko-${gs.grupo_segmento.id}-${vm.ies.id}`
      
      var svg = d3.select(chart_id)

      if (gs.no_aplica){
        svg.attr("height",0)
        return
      }

      let poblations = gs.poblations.filter(pob=> 
        !pob.sin_informacion && !pob.no_aplica)

      var base_data = poblations.reduce((tot, x)=>(
        tot.concat([{'sex':'mujer','value':x.mujeres, 'segmento': x.segmento},
              {'sex':'hombre','value':x.hombres, 'segmento': x.segmento}])
      ),[])

      //console.log(gs)
      //console.log(base_data)
      var filt_segm = vm.segmentos.filter(x=>
        x.grupo_segmento == gs.grupo_segmento.id)

      var pobs_count = base_data.length / 2

      var mekko_not_apply = !pobs_count && gs.grupo_segmento.mekko

      var is_mekko = gs.grupo_segmento.mekko && !mekko_not_apply


      var display_total = mekko_not_apply ||
        (gs.grupo_segmento.tipo.need_total && pobs_count > 1)


      /*svg
        .attr("width", vm.sizes.width + 300)
        .attr("height", is_mekko
            ? vm.sizes.height + mt + 10
            //Cada gráfica de barras horizontal vale 90, incluyendo el total
            : 90 * (pobs_count + (display_total ? 1.2 : 0)))*/
      //console.log(base_data.concat(filt_segm, {name: 'father'}))

      var height = is_mekko
        ? vm.sizes.height + mt + 10
        //Cada gráfica de barras horizontal vale 90, incluyendo el total
        : 90 * (pobs_count + (display_total ? 1.2 : 0))

      var width = vm.sizes.width + 235

      svg.attr("viewBox", [0, 0, width, height + 5])
        .classed("mekko-chart", true)


      if (is_mekko){
        var hierarchic_matrix = d3.stratify()
          .id(function(d) {
            if (d.name)
              return d.name
            else if (d.segmento)
              return `s-${d.segmento.id}-${d.sex}`
            else if (d.id)
              return d.id
          })
          .parentId(function(d) {
            if (d.name)
              return null
            else if (d.id)
              return 'father'
            else if (d.segmento)
              return d.segmento.id
          })
          (base_data.concat(filt_segm, {name: 'father'}))
          .sum(d=> d.value)

        var tree = treemapLayout(hierarchic_matrix);
        //var total_mekko = d3.format(",")(tree.value)
        //d3.select(`#pob-${gs.grupo_segmento.id}`).text(total_mekko);


        var nodes = svg
          .append("g")
          .selectAll('g.cell')
          .data(tree.leaves()) 
          .enter()
            .append('g')
            .attr('class', 'cell')
            .filter(d => d.depth > 1)
            .attr('transform', d => `translate(${d.y0}, ${d.x0 + mt})`)
        
        var rects = nodes
          .append("rect")
          .style('fill', d => vm[`color_${d.data.sex.substr(0,1)}`])
          .attr('height', d=> d.x1- d.x0)
          .attr('width', d=> d.y1- d.y0)
          .on("mousemove", function(d) {
            vm.is_tooltip = true
            vm.posX = d3.event.clientX
            vm.posY = d3.event.clientY
          })
          .on("mouseover", function(d) {
            vm.is_tooltip = true
            var h = d.parent.children.find(x=>x.data.sex == 'hombre').value
            var m = d.parent.children.find(x=>x.data.sex == 'mujer').value
            vm.tt_data = {
              segmento : d.data.segmento,
              nombre : d.data.segmento.nombre,
              description : d.data.segmento.descripcion,
              total_segmento : d.parent.value,
              h: h,
              m: m,
              perc: m/(h+m),
              seg: vm.format_perc(d.parent.value *100 / d.parent.parent.value),
              seg_tot: d3.format(",")(d.parent.value),
              g_seg_name: gs.grupo_segmento.nombre,
            }
          })
          .on("mouseout", function(d) {
            vm.is_tooltip = false
          })

        var percent_texts = nodes
          .filter(d=> (d.x1 - d.x0) > 15)
          .append("text")
          .style('fill', 'white')
          //.style("font-size", 16)
          .style("font-size", '12pt')
          .attr("pointer-events", "none")
          .attr('y', 16)
          .attr('x', d => d.data.sex == 'mujer' ? 5 : d.y1 - d.y0 -5)
          .attr("text-anchor", d => d.data.sex == 'mujer' ? "start" : "end")
          .text(d => (d.value / d.parent.value* 100).toFixed(0) + "%")

        var titles = nodes
          .filter(d => d.data.sex == 'mujer')
          .style("font-size", '12pt')
          .append("text")
          .attr("x", vm.sizes.width + 8)
          .attr("dy", "1em")
          //.style("font-size", 14)

        titles
          .append("tspan")
          .text(d=> d.data.segmento.nombre)
        
        titles
          .append("tspan")
          .attr("fill", "grey")
          .text(d=> ` (${d3.format(",")(d.parent.value)})`)

      }

      // línea divisoria
      svg
        .append('line')
        .attr('x1', vm.sizes.width/2)
        .attr('x2', vm.sizes.width/2)
        .attr('y1', 35)
        .attr('y2', vm.sizes.height + mt)
        .style('stroke-dasharray', ("4,5"))
        .style('stroke-width', 2)
        .style("stroke", "gray")


      var totals = mekko_not_apply 
        ? [{'sex': 'hombre', 'value': gs.hombres},
        {'sex': 'mujer', 'value': gs.mujeres}]
        : [{'sex': 'hombre', 'value': d3.sum(poblations, d=>d.hombres)},
        {'sex': 'mujer', 'value': d3.sum(poblations, d=>d.mujeres)}]

      //var total = d3.sum(totals, d=> d.value)
      var total_mekko = d3.sum(totals, d=> d.value)


      
      var func_ej2 = (sel) => sel
        .style('fill', d=> vm[`color_${d.sex.substr(0,1)}`])
        .attr("text-anchor", d => d.sex == 'mujer' ? "start" : "end")

      //Creando las gráficas no mekko
      var createHeaders = (totals, title, index=-1) => {
        var idx = index + 1
        var total = d3.sum(totals, d=> d.value)
        const is_total = title == 'Total'
        var headers = svg
          .append("g")
          //.attr('y', idx * 70)
          .attr("transform", `translate(0, ${idx * 80})`)
          .selectAll('text.head')
          .data(totals)
          .enter()


        if (idx === 0)
          headers
            .append('text')
            .attr('class', 'head')
            .style("font-size", 20)
            .call(func_ej2)
            .attr("dy", "1.3em")
            .attr('x', d => d.sex == 'mujer' ? 5 : vm.sizes.width -5)
            .text(d => d.sex == 'mujer' ? 'Mujeres' : 'Hombres')

        headers
          .append('text')
          .call(func_ej2)
          .style("font-size", 24)
          .attr('y', 60)
          .attr('x', d => d.sex == 'mujer' ? 5 : vm.sizes.width -5)
          .text(d=> (d.value/ total * 100).toFixed(1) + "%")

        headers
          .append('rect')
          .call(func_ej2)
          .attr('y', 70)
          .attr('x', d=> d.sex == 'mujer' ? 0 : xScale((total - d.value) / total))
          .attr('height', 8)//d=> d.x1- d.x0)
          .attr('width', d=> xScale(d.value/total))//d=> d.y1- d.y0)*/


        if (is_total){
          headers
            .filter(d => d.sex == 'mujer')
            .append('polygon')
            .attr('points',"0,0, 0,15.5, 8,23.5, 16,15.5, 16,0")
            .attr("fill", "black")
            .attr("transform", d => `translate(${xScale(d.value/total) -8}, 44)`)
          headers
            .filter(d => d.sex == 'mujer')
            .append('polygon')
            .attr('points',"0,0, 0,14, 7,21, 14,14, 14,0")
            .attr("fill", d=> vm.calcHeatColor(d.value / total))
            .attr("transform", d => `translate(${xScale(d.value/total) -7}, 45)`)
        }
        else {
          headers
            .filter(d => d.sex == 'mujer' && total)
            .append('circle')
            .attr('r', 9)
            .attr('stroke-width', 1)
            .attr('stroke','black')
            .attr("fill", d=> vm.calcHeatColor(d.value / total))
            .attr("transform", d => {
              return `translate(${xScale(d.value/total)}, 74)`
            })
        }


        let is_total_array = is_total ? false : Array.isArray(title)

        var sum_gs = headers
          .filter(d => d.sex == 'mujer')
          .append('text')
          .attr('x', vm.sizes.width + 8)
          .attr('y', is_total_array ? 46 : 35)
          .attr("dy", ".71em")
          //.attr("fill", "black")
          .attr("text-anchor", "start")
          .style("font-size", is_total ? '14pt' : '12pt')
          .style("font-weight", is_total ? 'bold' : 'regular')

        if (is_total_array){
          sum_gs
            .append("tspan")
            .attr('dy', 0)
            .attr('x', vm.sizes.width + 8)
            .text(title[0])
        }
        sum_gs
          .append("tspan")
          .attr('dy', 20)
          .attr('x', vm.sizes.width + 8)
          .text(is_total_array ? title[1] : title)

        sum_gs
          .append("tspan")
          //.style("font-size", 17)
          .attr('x', vm.sizes.width + 8)
          .attr("fill", "grey")
          .attr('dy', 21)
          .text(d3.format(",")(total))

      }
      
      //console.log(gs)


      //Creando los headers según distintas condiciones

      if (display_total || is_mekko)
        createHeaders(totals, 'Total')

      var need_total = gs.grupo_segmento.tipo.need_total ? 0 : 1
      if (!is_mekko && !mekko_not_apply){
        poblations.forEach((pob, idx)=>{
          //console.log(pob)

          var totals2 = [{'sex': 'hombre', 'value': pob.hombres},
            {'sex': 'mujer', 'value': pob.mujeres}]



          let title = pob.segmento.is_name_requiered 
            ? pob.nombre_plan : pob.segmento.nombre

          if (pob.segmento.is_name_requiered){
            const plan = pob.nombre_plan
            if (!plan) return
            if (plan.length < 28)
              title = plan
            else {
              let break_space = plan.lastIndexOf(' ', 28)
              title = [plan.substr(0, break_space), plan.substr(break_space+1)]
            }
          }

          createHeaders(totals2, title, idx - (display_total ? 0 : 1))

        })
      }

      //console.log(gs)
      var title_id = `#title-${gs.grupo_segmento.id}-${vm.ies.id}`

      // Texto de totales
      const is_plan = gs.grupo_segmento.tipo.clave == 'PLN'
      d3.select(title_id)
        .html(gs.grupo_segmento.nombre + 
          (is_plan ? '' :` (${d3.format(",")(total_mekko)})`))


      //50%
      svg
        .append('text')
        .attr('x', vm.sizes.width/2)
        .attr('y', 15)
        .text("50%")
        .attr("dy", ".71em")
        .attr("fill", "gray")
        .attr("text-anchor", "middle")
        .style("font-size",15)
      
    })
    this.reflow()

  },

  },
  watch: {
  },
  created(){
    this.$nextTick( () =>{
      this.mekkoChart()
      //this.gaugeChart2(2.34, data[1].items);
    })
  },
}
</script>

<style lang="scss" scoped>
  #ies-gauge g.arc {
    fill: steelblue;
  }

  #ies-gauge g.pointer {
    fill: #e85116;
    stroke: #b64011;
  }

  #ies-gauge g.label text {
    text-anchor: middle;
    font-size: 14px;
    font-weight: bold;
    fill: #666;
  }
</style>